import { getFromAPI } from '@/lib/api';
import useSWR from 'swr';
import useKeyValueStorage from '@/hooks/storage/useKeyValueStorage';
import { useEffect } from 'react';

export type Province =
	| 'onbekend'
	| 'groningen'
	| 'friesland'
	| 'drenthe'
	| 'overijssel'
	| 'flevoland'
	| 'gelderland'
	| 'utrecht'
	| 'noord_holland'
	| 'zuid_holland'
	| 'zeeland'
	| 'noord_brabant'
	| 'limburg';

const usePhysicalLocation = () => {
	// Store cached province in state
	const { value: cachedLocation, setValue: setCachedLocation } =
		useKeyValueStorage<{
			province: Province;
		}>('location', {
			province: 'onbekend',
		});

	// Fetch province from API
	const { data: remoteProvince } = useSWR('/identify/province', getFromAPI, {
		revalidateOnReconnect: true,
		revalidateIfStale: false,
		revalidateOnFocus: true,
		revalidateOnMount: false,
		errorRetryCount: 3,
		fallbackData: cachedLocation.province,
	});

	// Update cache if remote data is different
	useEffect(() => {
		if (remoteProvince && remoteProvince != cachedLocation.province) {
			setCachedLocation({
				...cachedLocation,
				province: remoteProvince,
			});
		}
	}, [remoteProvince, cachedLocation, setCachedLocation]);

	return cachedLocation;
};

export default usePhysicalLocation;
